var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiCarInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8317 11.3257L25.3333 16.5344H12.6667L14.915 11.3257H22.8317ZM14.25 18.0226C13.3792 18.0226 12.6667 18.6923 12.6667 19.5108C12.6667 20.3293 13.3792 20.999 14.25 20.999C15.1208 20.999 15.8333 20.3293 15.8333 19.5108C15.8333 18.6923 15.1208 18.0226 14.25 18.0226ZM23.75 18.0226C22.8792 18.0226 22.1667 18.6923 22.1667 19.5108C22.1667 20.3293 22.8792 20.999 23.75 20.999C24.6208 20.999 25.3333 20.3293 25.3333 19.5108C25.3333 18.6923 24.6208 18.0226 23.75 18.0226ZM33.25 7.60516V16.5344C33.25 24.7939 27.17 32.5177 19 34.3928C10.83 32.5177 4.75 24.7939 4.75 16.5344V7.60516L19 1.65234L33.25 7.60516ZM28.5 18.0226L25.08 10.5816C24.7633 9.71841 23.8767 9.09337 22.8317 9.09337H14.915C13.87 9.09337 12.9833 9.71841 12.6667 10.5816L9.5 18.0226V23.9754C9.5 24.7939 10.2125 25.4636 11.0833 25.4636H12.6667C13.5375 25.4636 14.25 24.7939 14.25 23.9754V22.4872H23.75V23.9754C23.75 24.7939 24.4625 25.4636 25.3333 25.4636H26.9167C27.7875 25.4636 28.5 24.7939 28.5 23.9754V18.0226Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCarInsurance);
export default __webpack_public_path__ + "static/media/mdi_car_insurance.b9e0b6b5767234149fcb7c67ad6b37e6.svg";
export { ForwardRef as ReactComponent };